import "flickity/js/index";

import Flickity from "flickity";

function startSlider(sliderWrapper) {
	var slider = sliderWrapper.querySelector(".slider");
	let slides = slider.querySelectorAll(".slide");
	var sliderContentWrapper = sliderWrapper.querySelector(
		".slider-content-wrapper"
	);

	var sliderNext = sliderWrapper.querySelector(
		".flickity-prev-next-button.next"
	);
	var sliderPrev = sliderWrapper.querySelector(
		".flickity-prev-next-button.prev"
	);

	var flkty = new Flickity(slider, {
		wrapAround: true,
		autoPlay: 10000,
		pauseAutoPlayOnHover: false,
		setGallerySize: false,
		prevNextButtons: false,
	});
	var startIndex = 0;

	sliderNext.addEventListener("click", function () {
		flkty.next();
	});

	sliderPrev.addEventListener("click", function () {
		flkty.previous();
	});

	for (let index = 0; index < slides.length; index++) {
		const slide = slides[index];

		// Has linked element
		if (slide.hasAttribute("data-linked-element")) {
			let linkedElement = slide.dataset.linkedElement;
			// console.log(linkedElement);
			// console.log(document.querySelectorAll(linkedElement));
			slide.linkedElement = document.querySelectorAll(linkedElement);

			if (slide.linkedElement) {
				slide.linkedElement.forEach((element) => {
					if (index !== startIndex) {
						element.classList.add("atk-slider-hidden");
						element.classList.remove("atk-slider-visible");
					} else {
						element.classList.add("atk-slider-visible");
						element.classList.remove("atk-slider-hidden");
					}
				});
			}
		}

		// Looking for related content
		if (sliderContentWrapper) {
			slide.linkedContent = sliderContentWrapper.querySelectorAll(
				'[data-key="' + index + '"]'
			);

			slide.linkedContent.forEach((content) => {
				if (index === 0 && slide.linkedContent) {
					content.classList.remove("inactive");
				}
				content.addEventListener("click", function () {
					// console.log("click");
					flkty.select(index);
				});
			});
		}
	}

	var currentIndex = startIndex;
	flkty.on("change", function (index) {
		var currentSlide = slides[currentIndex];
		var nextSlide = slides[index];

		if (currentSlide.linkedElement) {
			currentSlide.linkedElement.forEach((element) => {
				element.classList.add("atk-slider-hidden");
				element.classList.remove("atk-slider-visible");
			});
		}
		if (nextSlide.linkedElement) {
			nextSlide.linkedElement.forEach((element) => {
				element.classList.add("atk-slider-visible");
				element.classList.remove("atk-slider-hidden");
			});
		}

		if (currentSlide.linkedContent) {
			currentSlide.linkedContent.forEach((content) => {
				content.classList.add("inactive");
			});
		}

		if (nextSlide.linkedContent) {
			nextSlide.linkedContent.forEach((content) => {
				content.classList.remove("inactive");
			});
		}

		currentIndex = index;
	});
}

function startSliders() {
	let sliders = document.querySelectorAll(".atk-slider");

	for (let index = 0; index < sliders.length; index++) {
		const sliderWrapper = sliders[index];
		startSlider(sliderWrapper);
	}
}

startSliders();
